import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 27.65 27.65' {...props}>
    <defs />
    <g id='Layer_2' data-name='Layer 2'>
      <g id='component_info' data-name='component info'>
        <path
          className='cls-1'
          transform='rotate(-45 13.817 13.827)'
          d='M12.44-4.34h2.77v36.33h-2.77z'
        />
        <path
          className='cls-1'
          transform='rotate(-45 13.817 13.827)'
          d='M-4.34 12.44h36.33v2.77H-4.34z'
        />
      </g>
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/CloseIcon.js